/** Adds protocol and hostname to a relative URL.
 * WARNING: This function references `window`
 */
export default (relativeUrl: string) => {
  const shouldAddSlash = !relativeUrl.startsWith('/');
  const baseUrl = `${window.location.protocol}//${window.location.host}`;
  return [baseUrl, relativeUrl].join(shouldAddSlash ? '/' : '');
};
